/*
 * 
 * 
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.57
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import Error from '../model/Error';
import JsonNode from '../model/JsonNode';
import UpdateManyRequestBody from '../model/UpdateManyRequestBody';

/**
* Lk service.
* @module api/LkApi
* @version 1.0.0
*/
export default class LkApi {

  /**
  * Constructs a new LkApi. 
  * @alias module:api/LkApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instanc
  e} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  /**
   * Callback function to receive the result of the applyLKConnectorResults operation.
   * @callback moduleapi/LkApi~applyLKConnectorResultsCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Error{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод подтверждения результата
   * @param {module:model/JsonNode} body 
   * @param {String} dataset 
   * @param {module:api/LkApi~applyLKConnectorResultsCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  applyLKConnectorResults(body, dataset, callback) {

    let postBody = JSON.stringify(body || {});
    // verify the required parameter 'body' is set
    if (body === undefined || body === null) {
      throw new Error("Missing the required parameter 'body' when calling applyLKConnectorResults");
    }
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling applyLKConnectorResults");
    }

    let pathParams = {

    };
    let queryParams = {
      'dataset': dataset
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = Error;

    return this.apiClient.callApi(
      '/lk/connectorResults', 'POST',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the createObject operation.
   * @callback moduleapi/LkApi~createObjectCallback
   * @param {String} error Error message, if any.
   * @param {Object{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод создания объекта в базе данных
   * @param {{String: Object}} body 
   * @param {String} database 
   * @param {String} dataset 
   * @param {module:api/LkApi~createObjectCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  createObject(body, database, dataset, timeFieldsNames = [], callback) {
    let copyObject = {
      timeFieldsNames: timeFieldsNames,
      fields: body
    };

    let postBody = JSON.stringify(copyObject);
    // verify the required parameter 'body' is set
    if (body === undefined || body === null) {
      throw new Error("Missing the required parameter 'body' when calling createObject");
    }
    // verify the required parameter 'database' is set
    if (database === undefined || database === null) {
      throw new Error("Missing the required parameter 'database' when calling createObject");
    }
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling createObject");
    }

    let pathParams = {

    };
    let queryParams = {
      'database': database, 'dataset': dataset
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = Object;

    return this.apiClient.callApi(
      '/lk/object', 'POST',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the deleteLKDataset operation.
   * @callback moduleapi/LkApi~deleteLKDatasetCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Error{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод удаления датасета
   * @param {String} dataset 
   * @param {module:api/LkApi~deleteLKDatasetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  deleteLKDataset(dataset, callback) {

    let postBody = null;
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling deleteLKDataset");
    }

    let pathParams = {

    };
    let queryParams = {
      'dataset': dataset
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Error;

    return this.apiClient.callApi(
      '/lk/dataset', 'DELETE',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the deleteObject operation.
   * @callback moduleapi/LkApi~deleteObjectCallback
   * @param {String} error Error message, if any.
   * @param {Object{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод удаления объекта в базе данных
   * @param {String} database 
   * @param {String} dataset 
   * @param {String} id 
   * @param {module:api/LkApi~deleteObjectCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  deleteObject(database, dataset, id, callback) {

    let postBody = null;
    // verify the required parameter 'database' is set
    if (database === undefined || database === null) {
      throw new Error("Missing the required parameter 'database' when calling deleteObject");
    }
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling deleteObject");
    }
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling deleteObject");
    }

    let pathParams = {

    };
    let queryParams = {
      'database': database, 'dataset': dataset, '_id': id
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Object;

    return this.apiClient.callApi(
      '/lk/object', 'DELETE',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the getDatasets operation.
   * @callback moduleapi/LkApi~getDatasetsCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Error{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод получения датасетов
   * @param {Object} opts Optional parameters
   * @param {Number} opts.limit 
   * @param {Number} opts.skip 
   * @param {module:api/LkApi~getDatasetsCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  getDatasets(opts, callback) {
    opts = opts || {};
    let postBody = null;

    let pathParams = {

    };
    let queryParams = {
      'limit': opts['limit'], 'skip': opts['skip'], 'filter': JSON.stringify(opts['filter'])
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Error;

    return this.apiClient.callApi(
      '/lk/datasets', 'GET',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }



  getTarif(opts, callback) {
    opts = opts || {};
    let postBody = null;
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};

    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Error;

    return this.apiClient.callApi(
      '/lk/tarif', 'GET',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }


  /**
   * Callback function to receive the result of the getToken operation.
   * @callback moduleapi/LkApi~getTokenCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Error{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод получения токена
   * @param {String} dataset 
   * @param {Object} opts Optional parameters
   * @param {String} opts.database 
   * @param {module:api/LkApi~getTokenCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  getToken(dataset, opts, callback) {
    opts = opts || {};
    let postBody = null;
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling getToken");
    }

    let pathParams = {

    };
    let queryParams = {
      'dataset': dataset, 'database': opts['database']
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Error;

    return this.apiClient.callApi(
      '/lk/token', 'GET',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the lKConnectionTask operation.
   * @callback moduleapi/LkApi~lKConnectionTaskCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Error{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод создания задачи
   * @param {module:model/JsonNode} body 
   * @param {String} dataset 
   * @param {String} database 
   * @param {Object} opts Optional parameters
   * @param {String} opts.crossType 
   * @param {String} opts.version 
   * @param {String} opts.partsName 
   * @param {String} opts.detectedRegionName 
   * @param {String} opts.detectedMunicipalitetName 
   * @param {module:api/LkApi~lKConnectionTaskCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  lKConnectionTask(body, dataset, database, opts, callback) {
    opts = opts || {};
    let postBody = JSON.stringify(body);
    // verify the required parameter 'body' is set
    if (body === undefined || body === null) {
      throw new Error("Missing the required parameter 'body' when calling lKConnectionTask");
    }
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling lKConnectionTask");
    }
    // verify the required parameter 'database' is set
    //if (database === undefined || database === null) {
    //  throw new Error("Missing the required parameter 'database' when calling lKConnectionTask");
    //}

    let pathParams = {

    };
    let queryParams = {
      'dataset': dataset,
      'database': database,
      'crossType': opts['crossType'],
      'version': opts['version'],
      'partsName': opts['partsName'],
      'filter': JSON.stringify(opts['filter'] || {}),
      'features': JSON.stringify(opts['features'] || {}),
      'detectedRegionName': opts['detectedRegionName'],
      'detectedMunicipalitetName': opts['detectedMunicipalitetName']
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = Error;

    return this.apiClient.callApi(
      '/lk/connectorTask', 'POST',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the lKDecomposerTask operation.
   * @callback moduleapi/LkApi~lKDecomposerTaskCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Error{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод создания задачи
   * @param {String} dataset 
   * @param {String} addressField 
   * @param {module:api/LkApi~lKDecomposerTaskCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  lKDecomposerTask(dataset, addressField, callback) {

    let postBody = null;
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling lKDecomposerTask");
    }
    // verify the required parameter 'addressField' is set
    if (addressField === undefined || addressField === null) {
      throw new Error("Missing the required parameter 'addressField' when calling lKDecomposerTask");
    }

    let pathParams = {

    };
    let queryParams = {
      'dataset': dataset, 'addressField': addressField
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Error;

    return this.apiClient.callApi(
      '/lk/decomposerTask', 'POST',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the lKExporterTask operation.
   * @callback moduleapi/LkApi~lKExporterTaskCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Error{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод создания задачи
   * @param {module:model/JsonNode} body 
   * @param {String} datasetId 
   * @param {String} format 
   * @param {Object} opts Optional parameters
   * @param {String} opts.sortBy 
   * @param {String} opts.sortOrder 
   * @param {module:api/LkApi~lKExporterTaskCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  lKExporterTask(body, datasetId, format, opts, callback) {
    opts = opts || {};
    let postBody = JSON.stringify(body || {});

    // verify the required parameter 'datasetId' is set
    if (datasetId === undefined || datasetId === null) {
      throw new Error("Missing the required parameter 'datasetId' when calling lKExporterTask");
    }
    // verify the required parameter 'format' is set
    if (format === undefined || format === null) {
      throw new Error("Missing the required parameter 'format' when calling lKExporterTask");
    }

    let pathParams = {

    };
    let queryParams = {
      'datasetId': datasetId,
      'format': format,
      'sortBy': opts['sortBy'],
      'sortOrder': opts['sortOrder']
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = Error;

    return this.apiClient.callApi(
      '/lk/exporterTask', 'POST',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the lKGeometryTransformerTask operation.
   * @callback moduleapi/LkApi~lKGeometryTransformerTaskCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Error{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод создания задачи
   * @param {String} dataset 
   * @param {String} inputType 
   * @param {Object} opts Optional parameters
   * @param {String} opts.columnX 
   * @param {String} opts.columnY 
   * @param {String} opts.columnWKT 
   * @param {String} opts.coordSystemProj4 
   * @param {module:api/LkApi~lKGeometryTransformerTaskCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  lKGeometryTransformerTask(dataset, inputType, opts, callback) {
    opts = opts || {};
    let postBody = null;
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling lKGeometryTransformerTask");
    }
    // verify the required parameter 'inputType' is set
    if (inputType === undefined || inputType === null) {
      throw new Error("Missing the required parameter 'inputType' when calling lKGeometryTransformerTask");
    }

    let pathParams = {

    };
    let queryParams = {
      'dataset': dataset, 'inputType': inputType, 'columnX': opts['columnX'], 'columnY': opts['columnY'], 'columnWKT': opts['columnWKT'], 'coordSystemProj4': opts['coordSystemProj4']
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Error;

    return this.apiClient.callApi(
      '/lk/geometryTransformer', 'POST',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the lKNormaliserTask operation.
   * @callback moduleapi/LkApi~lKNormaliserTaskCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Error{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод создания задачи
   * @param {module:model/JsonNode} body 
   * @param {String} dataset 
   * @param {module:api/LkApi~lKNormaliserTaskCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  lKNormaliserTask(body, dataset, callback) {

    let postBody = body;
    // verify the required parameter 'body' is set
    if (body === undefined || body === null) {
      throw new Error("Missing the required parameter 'body' when calling lKNormaliserTask");
    }
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling lKNormaliserTask");
    }

    let pathParams = {

    };
    let queryParams = {
      'dataset': dataset
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = Error;

    return this.apiClient.callApi(
      '/lk/normaliserTask', 'POST',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the lKPublisherTask operation.
   * @callback moduleapi/LkApi~lKPublisherTaskCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Error{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод создания задачи
   * @param {String} dataset 
   * @param {module:api/LkApi~lKPublisherTaskCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  lKPublisherTask(dataset, callback) {

    let postBody = null;
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling lKPublisherTask");
    }

    let pathParams = {

    };
    let queryParams = {
      'dataset': dataset
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Error;

    return this.apiClient.callApi(
      '/lk/publisherTask', 'POST',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the updateDatasetMetadata operation.
   * @callback moduleapi/LkApi~updateDatasetMetadataCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Error{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод изменения метадаты датасета
   * @param {module:model/JsonNode} body 
   * @param {String} dataset 
   * @param {Object} opts Optional parameters
   * @param {String} opts.datasetName 
   * @param {module:api/LkApi~updateDatasetMetadataCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  updateDatasetMetadata(body, dataset, opts, callback) {
    opts = opts || {};
    let postBody = JSON.stringify(body);
    // verify the required parameter 'body' is set
    if (body === undefined || body === null) {
      throw new Error("Missing the required parameter 'body' when calling updateDatasetMetadata");
    }
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling updateDatasetMetadata");
    }

    let pathParams = {

    };
    let queryParams = {
      'dataset': dataset, 'datasetName': opts['datasetName']
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = Error;

    return this.apiClient.callApi(
      '/lk/datasetMetadata', 'PATCH',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the updateManyObjects operation.
   * @callback moduleapi/LkApi~updateManyObjectsCallback
   * @param {String} error Error message, if any.
   * @param {Object{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод изменения нескольких объектов в базе данных (UpdateManyObjects)
   * @param {module:model/UpdateManyRequestBody} body 
   * @param {String} database 
   * @param {String} dataset 
   * @param {module:api/LkApi~updateManyObjectsCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  updateManyObjects(body, database, dataset, callback) {

    let postBody = JSON.stringify(body);
    // verify the required parameter 'body' is set
    if (body === undefined || body === null) {
      throw new Error("Missing the required parameter 'body' when calling updateManyObjects");
    }
    // verify the required parameter 'database' is set
    if (database === undefined || database === null) {
      throw new Error("Missing the required parameter 'database' when calling updateManyObjects");
    }
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling updateManyObjects");
    }

    let pathParams = {

    };
    let queryParams = {
      'database': database, 'dataset': dataset
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = Object;

    return this.apiClient.callApi(
      '/lk/objects', 'PATCH',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the updateObject operation.
   * @callback moduleapi/LkApi~updateObjectCallback
   * @param {String} error Error message, if any.
   * @param {Object{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод изменения объекта в базе данных (UpdateObject)
   * @param {{String: Object}} body 
   * @param {String} database 
   * @param {String} dataset 
   * @param {String} id 
   * @param {Object} opts Optional parameters
   * @param {Boolean} opts.partial  (default to <.>)
   * @param {module:api/LkApi~updateObjectCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  updateObject(body, database, dataset, id, opts, timeFieldsNames = [], callback) {
    let copyObject = {
      timeFieldsNames: timeFieldsNames,
      fields: body
    };

    opts = opts || {};
    let postBody = JSON.stringify(copyObject);
    // verify the required parameter 'body' is set
    if (body === undefined || body === null) {
      throw new Error("Missing the required parameter 'body' when calling updateObject");
    }
    // verify the required parameter 'database' is set
    if (database === undefined || database === null) {
      throw new Error("Missing the required parameter 'database' when calling updateObject");
    }
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling updateObject");
    }
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling updateObject");
    }

    let pathParams = {

    };
    let queryParams = {
      'database': database, 'dataset': dataset, '_id': id, 'partial': opts['partial']
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = Object;

    return this.apiClient.callApi(
      '/lk/object', 'PATCH',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the uploadDataset operation.
   * @callback moduleapi/LkApi~uploadDatasetCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Error{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод загрузки датасета
   * @param {Object} opts Optional parameters
   * @param {Blob} opts.file 
   * @param {String} opts.dataset 
   * @param {String} opts.fileName 
   * @param {Boolean} opts.labelsInFirstRow 
   * @param {module:api/LkApi~uploadDatasetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  uploadDataset(opts, callback) {
    opts = opts || {};
    let postBody = null;

    let pathParams = {

    };
    let queryParams = {
      'dataset': opts['dataset'], 'fileName': opts['fileName'], 'labelsInFirstRow': opts['labelsInFirstRow']
    };
    let headerParams = {

    };
    let formParams = {
      'file': opts['file']
    };

    let authNames = [];
    let contentTypes = ['multipart/form-data'];
    let accepts = ['application/json'];
    let returnType = Error;

    return this.apiClient.callApi(
      '/lk/dataset', 'POST',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }

}